import { tv } from 'tailwind-variants'

export const icon = tv({
  slots: {
    container: 'relative flex shrink-0 flex-row items-center justify-center',
    bgShapeContainer: 'absolute',
    image: 'relative z-10 [&>img]:relative',
  },
})
